import { FC } from "react";

import { FormChip, FormChipProps } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedFormArchivedChipProps = Omit<FormChipProps, "vibe" | "variant" | "label">;

export const ThemedFormArchivedChip: FC<ThemedFormArchivedChipProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return <FormChip vibe="danger" variant="outlined" label={t("common", "form_archived")} {...rest} />;
};
